// extracted by mini-css-extract-plugin
export default {"root":"gaKyka","icon":"ZGcQAB","modal":"UZC0QG","button":"qsaZ8j","modelBackground":"C50_NT","iframeWrapper":"H73nH8"};